module.exports = __webpack_public_path__ + "static/media/supermandog.64e47eaf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supermandog.svg
// module id = 258
// module chunks = 0